import React, { useContext } from 'react'
import { useConnect } from 'wagmi'
import { WalletAddressContext } from '../constant/constant'
import { closeIcon } from '../constant/icon'
import metamaskWallet from './walletImages/metamask.png'
import walletConnectLogo from './walletImages/walletConnect.png'

const ConnectWallet = ({ setConnectWalletModal }) => {
    const { setWalletAddress } = useContext(WalletAddressContext)

    const { connect, connectors, isLoading, pendingConnector } = useConnect({
        onSuccess(data) {
            const connectedAddress = data.accounts?.[0]
            if (connectedAddress) {
                setWalletAddress(connectedAddress)
            }
            setConnectWalletModal(false)
        },
    })

    // Map images to connector IDs or indexes
    const walletImages = {
        'metaMask': metamaskWallet,
        'walletConnect': walletConnectLogo
    };

    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 transition-all animate-fade-in">
            {/* BACKDROP */}
            <div
                className="absolute inset-0 bg-black/80 backdrop-blur-sm"
                onClick={() => setConnectWalletModal(false)}
            />

            {/* MODAL CONTAINER */}
            <div className="relative w-full max-w-md transform transition-all animate-fade-in-up">
                <div className="overflow-hidden rounded-3xl border border-zinc-200 bg-white shadow-2xl dark:border-zinc-800 dark:bg-zinc-950">

                    {/* HEADER */}
                    <div className="flex items-center justify-between border-b border-zinc-200 bg-zinc-50 p-5 dark:border-zinc-800/60 dark:bg-zinc-900/40">
                        <div>
                            <h3 className="text-xl font-bold text-zinc-900 dark:text-white">Connect Wallet</h3>
                            <p className="mt-0.5 text-xs text-zinc-500 dark:text-zinc-500">Select your preferred provider</p>
                        </div>
                        <button
                            className="rounded-xl bg-zinc-200/80 p-2 text-zinc-600 transition-all hover:bg-zinc-300 hover:text-zinc-900 dark:bg-zinc-800/50 dark:text-zinc-400 dark:hover:bg-zinc-700 dark:hover:text-white"
                            onClick={() => setConnectWalletModal(false)}
                        >
                            <i className={`${closeIcon} text-lg`}></i>
                        </button>
                    </div>

                    {/* WALLET LIST */}
                    <div className="p-6 space-y-4">
                        {connectors.map((connector) => {
                            const isConnecting = isLoading && connector.id === pendingConnector?.id;

                            return (
                                <button
                                    key={connector.id}
                                    onClick={() => connect({ connector })}
                                    disabled={isConnecting}
                                    className={`group relative flex w-full items-center justify-between rounded-2xl border p-4 transition-all duration-300
                                        ${isConnecting
                                            ? 'border-teal-500 bg-teal-50 ring-1 ring-teal-500 dark:border-teal-500 dark:bg-teal-500/10'
                                            : 'border-zinc-200 bg-zinc-50 hover:border-zinc-300 hover:bg-zinc-100 dark:border-zinc-800 dark:bg-zinc-900/40 dark:hover:border-zinc-600 dark:hover:bg-zinc-800'}`}
                                >
                                    <div className="flex items-center gap-4">
                                        <div className="relative">
                                            <img
                                                className="h-10 w-10 object-contain rounded-lg"
                                                src={walletImages[connector.id] || metamaskWallet}
                                                alt={connector.name}
                                            />
                                            {isConnecting && (
                                                <span className="absolute -top-1 -right-1 flex h-3 w-3">
                                                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"></span>
                                                    <span className="relative inline-flex rounded-full h-3 w-3 bg-blue-500"></span>
                                                </span>
                                            )}
                                        </div>
                                        <div className="text-left">
                                            <span className="block text-sm font-bold text-zinc-900 transition-colors group-hover:text-teal-700 dark:text-white dark:group-hover:text-teal-300">
                                                {connector.name}
                                            </span>
                                            <span className="block text-[10px] font-medium uppercase tracking-tight text-zinc-500">
                                                {isConnecting ? 'Waiting for approval...' : 'Available'}
                                            </span>
                                        </div>
                                    </div>

                                    <div className="text-zinc-400 transition-all group-hover:text-teal-600 dark:text-zinc-600 dark:group-hover:text-teal-400">
                                        {isConnecting ? (
                                            <div className="h-5 w-5 animate-spin rounded-full border-2 border-teal-500 border-t-transparent dark:border-teal-400"></div>
                                        ) : (
                                            <i className="fas fa-chevron-right text-xs"></i>
                                        )}
                                    </div>
                                </button>
                            );
                        })}
                    </div>

                    {/* FOOTER */}
                    <div className="border-t border-zinc-200 bg-zinc-50 p-4 text-center dark:border-zinc-800/60 dark:bg-zinc-900/40">
                        <p className="text-[10px] font-medium leading-relaxed text-zinc-500">
                            By connecting, you agree to the <br />
                            <span className="cursor-pointer text-teal-700 hover:underline dark:text-teal-400">Terms of Service</span> and <span className="cursor-pointer text-teal-700 hover:underline dark:text-teal-400">Privacy Policy</span>.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ConnectWallet